var path = '/components/history/back-button.component.html';
var html = "<div ng-click=\"$ctrl.goBack()\">\n\t<i class=\"fa fa-angle-left\"></i>\n\t<span ng-if=\"$ctrl.title\" style=\"margin-left: 5px;\">{{::$ctrl.title}}</span>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;